// removed by extract-text-webpack-plugin
module.exports = {"infoCirclePopoverBody":"MzIyB","inforCircleButton":"_2vska"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InfoCircle/index.sass
// module id = 1477
// module chunks = 1